import { render, staticRenderFns } from "./booking-confirmation.vue?vue&type=template&id=18a18ea8&scoped=true"
import script from "./booking-confirmation.vue?vue&type=script&lang=js"
export * from "./booking-confirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a18ea8",
  null
  
)

export default component.exports